import { render, staticRenderFns } from "./deleteConfirmationModal.vue?vue&type=template&id=3a20d024&"
import script from "./deleteConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./deleteConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a20d024')) {
      api.createRecord('3a20d024', component.options)
    } else {
      api.reload('3a20d024', component.options)
    }
    module.hot.accept("./deleteConfirmationModal.vue?vue&type=template&id=3a20d024&", function () {
      api.rerender('3a20d024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/branches/components/deleteConfirmationModal.vue"
export default component.exports